function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable */

/* ---------------------------------------------------
Import Modules
----------------------------------------------------- */

import Classy from '@meteora-digital/classy';

/* ---------------------------------------------------
Indexed Search Controller
----------------------------------------------------- */
var IndexedSearchFormController = /*#__PURE__*/function (_Classy) {
  _inherits(IndexedSearchFormController, _Classy);
  var _super = _createSuper(IndexedSearchFormController);
  function IndexedSearchFormController(form) {
    var _this;
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, IndexedSearchFormController);
    _this = _super.call(this);
    // Set the form
    _this.form = form;
    // Set the field inputs
    _this.fields = [];
    // Set up a list of filters
    _this.filters = [];
    // XHR request
    _this.xhr = new XMLHttpRequest();
    // Set up a mutation observer to check if the form inputs change
    _this.observer = new MutationObserver(function () {
      return _this.update();
    });
    // An object to set some timeouts
    _this.timeouts = {};
    // An object to hold a cache of previous requests
    _this.cache = {};
    // Set a value for the search term
    _this.value = {
      'parameter': {},
      'filter': {}
    };

    // Set up the settings
    // this.filterType = settings.filterType || 'exclusive';
    // Set up the parameters which will update the filters
    _this.parametersThatUpdateFilters = Array.isArray(settings.parametersThatUpdateFilters) ? settings.parametersThatUpdateFilters : [];

    // Prevent the default form submission
    _this.form.addEventListener('submit', function (event) {
      event.preventDefault();
      _this.submit();
    });
    _this.form.addEventListener('reset', function (event) {
      event.preventDefault();
      _this.clearFilters();
      _this.submit();
    });

    // Set up the observer
    _this.observer.observe(_this.form, {
      childList: true,
      subtree: true
    });

    // Update immediately
    _this.update();
    return _this;
  }

  /*
  This method will return the event listener for the field based on its type
  */
  _createClass(IndexedSearchFormController, [{
    key: "getListener",
    value: function getListener(field) {
      switch (field.type) {
        case 'checkbox':
        case 'radio':
        case 'select-one':
        case 'select-multiple':
          return 'change';
        default:
          return 'input';
      }
    }

    /*
    This update() method will update this.fields array
    It will remove any fields that are no longer on the page,
    as well as adding any newly added fields,
    making sure we dont add fields that already exist in the array.
    */
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;
      // Get all the fields on the page
      var fields = _toConsumableArray(this.form.elements);

      // Start by adding the new fields to the array
      _toConsumableArray(this.form.elements).forEach(function (element) {
        // Make sure the field doesnt already exist in the array
        if (fields.includes(element)) return;
        // If there is no input name, return
        if (!element.name) return;
        // If the input is disabled, return
        if (element.disabled) return console.log(element.name + ' is disabled');
        // If it doesnt, add it to the array
        fields.push(element);
      });

      // Loop through the fields array
      fields.forEach(function (field, index) {
        // Make sure the field exists on the page
        if (_this2.form.contains(field)) return;

        // Otherwise, remove it from the array
        fields.splice(index, 1);
      });

      // Loop through all the fields, filtering out the fields held in this.fields
      fields.filter(function (field) {
        return !_this2.fields.includes(field);
      }).forEach(function (input) {
        // These fields are all new, we need to set up the event listeners

        // If this input is in the filters array, initialize it as a filter
        if (_this2.filters.includes(input)) return _this2.initialize(input, 'filter');

        // Otherwise, initialize it as a parameter
        _this2.initialize(input, 'parameter');
      });

      // Set this.fields to the new fields array
      this.fields = fields;

      // The update callback
      this.callback('update', this.fields);
    }
  }, {
    key: "initialize",
    value: function initialize(input) {
      var _this3 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'parameter';
      // Function to run when the input is changed
      var onChange = function onChange() {
        if (input.disabled) return;

        // If this.value[type][input.name] is undefined, set it to an empty array
        if (_this3.value[type][input.name] === undefined) _this3.value[type][input.name] = [];

        // Store this input's value storage in a variable
        var storage = [];
        switch (input.type) {
          case 'checkbox':
            // If the checkbox is checked, add the value to the array
            if (input.checked) storage.push(input.value);else {
              try {
                // Otherwise, remove the value from the array
                _this3.value[type][input.name] = _this3.value[type][input.name].filter(function (value) {
                  return value !== input.value;
                });
              } catch (err) {}
            }
            // Exit the switch statement
            break;
          case 'radio':
            // If the radio is checked, set the value to the input value
            if (input.checked) storage = input.value;else {
              try {
                // Otherwise, remove the value from the array
                _this3.value[type][input.name] = _this3.value[type][input.name].filter(function (value) {
                  return value !== input.value;
                });
              } catch (err) {}
            }
            // Exit the switch statement
            break;
          case 'select-multiple':
            // Loop through all the options
            _toConsumableArray(input.options).forEach(function (option) {
              // If the option is selected, add it to the array
              if (option.selected) {
                storage.push(option.value);
              } else {
                try {
                  // Otherwise, remove it from the array
                  _this3.value[type][input.name] = _this3.value[type][input.name].filter(function (value) {
                    return value !== option.value;
                  });
                } catch (err) {}
              }
            });
            // Exit the switch statement
            break;
          default:
            // Set the value to the input value
            storage = input.value;
            // Exit the switch statement
            break;
        }

        // If the storage is not an array, set the value to the storage and return
        if (!Array.isArray(storage)) return _this3.value[type][input.name] = storage;
        if (Array.isArray(storage)) {
          // Remove all empty values from the array
          storage = storage.filter(function (value) {
            return value !== '';
          });

          // Add the items from the storage array to the value array
          storage.forEach(function (value) {
            // If the value is already in the array, return
            if (_this3.value[type][input.name].includes(value)) return;
            // Otherwise, add it to the array
            _this3.value[type][input.name].push(value);
          });
        }

        // If the value is an empty array, delete it
        if (Array.isArray(_this3.value[type][input.name]) && _this3.value[type][input.name].length === 0) {
          delete _this3.value[type][input.name];
        }

        // If the value is an empty string, delete it
        if (_this3.value[type][input.name] === '') {
          delete _this3.value[type][input.name];
        }
      };

      // Add the event listener
      input.addEventListener(this.getListener(input), function () {
        onChange();
        _this3.change();
      });

      // Initialize the value
      onChange();

      // Add the field to this.fields
      this.fields.push(input);
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this4 = this;
      // Abort the current XHR request
      this.xhr.abort();

      // Clear the timeouts
      clearTimeout(this.timeouts.submit);

      // Set a timeout to run the submit callback
      this.timeouts.submit = setTimeout(function () {
        // Create a new string for the query string
        var parameters = '?';
        var filters = '';

        // Loop through the parameters and add the key and value to the string
        Object.keys(_this4.value['parameter']).forEach(function (key) {
          if (key == '') return;
          if (_this4.value['parameter'][key] == '') return;
          parameters += "".concat(key, "=").concat(_this4.value.parameter[key], "&");
        });
        if (parameters == '?') return;

        // Otherwise, add the filters to the data string
        filters += "filters=".concat(encodeURIComponent(JSON.stringify(_this4.value['filter'])));

        // Set the XHR request
        _this4.xhr.open('GET', _this4.form.action + parameters + filters, true);

        // Send the request
        _this4.xhr.send();

        // On load
        _this4.xhr.onload = function () {
          // Let response be the response text
          var response;
          try {
            // Parse the response
            response = JSON.parse(_this4.xhr.responseText);
            var update = false;

            // Convert the parameters string to an object
            var params = Object.fromEntries(new URLSearchParams(parameters));

            // If there is a cache for the parameters set the cache to a copy of the params
            if (_this4.cache['parameters'] === undefined) {
              _this4.cache['parameters'] = _objectSpread({}, params);
              update = true;
            } else {
              // Loop through the params
              Object.keys(params).forEach(function (key) {
                // If the parameter is a parameter that updates the filters
                if (_this4.parametersThatUpdateFilters.includes(key)) {
                  // If the parameter has changed, update the filters
                  if (_this4.cache['parameters'][key] !== params[key]) {
                    update = true;
                    // And update the cache
                    _this4.cache['parameters'][key] = params[key];
                  }
                }
              });
            }

            // If there is no control over which parameters update the filters, or if the required parameters have changed, update the filters
            if (_this4.parametersThatUpdateFilters.length === 0 || update) {
              // Render the new filters from the response
              _this4.render(response['filters']);
            }

            // The submit callback
            _this4.callback('submit', response['results']);
          } catch (err) {
            // If the response is not JSON, return the response text
            response = _this4.xhr.responseText;
            // The submit callback
            _this4.callback('submit', response);
          }
        };
      }, 300);
    }

    /*
    This is the default render function.
    This function can be overriden by passing a function to the onRender method
    */
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      // If the onRenderFunction is defined, run it
      if (this.onRenderFunction !== undefined) return this.onRenderFunction(data);

      // Create a new div
      var filters = document.createElement('div');
      // Create a reset button
      var reset = document.createElement('button');

      // Set the reset button text
      reset.innerText = 'RESET ALL';
      // Set the reset button type
      reset.type = 'reset';

      // Empty the filters array
      this.filters = [];

      // Loop through the data
      data.forEach(function () {
        var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // Create a new div
        var fieldset = document.createElement('div');
        // Create a legend
        var legend = document.createElement('legend');

        // Set the legend text
        legend.innerText = filter.label;

        // Append the legend to the fieldset
        fieldset.appendChild(legend);

        // Loop all the options
        filter.options.forEach(function (option, index) {
          // Create a new div
          var div = document.createElement('div');
          // Create a checkbox input
          var checkbox = document.createElement('input');
          // Create a label
          var label = document.createElement('label');

          // Set the checkbox type
          checkbox.type = 'checkbox';
          // Set the checkbox name
          checkbox.name = filter.field;
          // Set the checkbox ID
          checkbox.id = checkbox.name + '-' + index;
          // Set the checkbox value
          checkbox.value = option.value;

          // Set the label text
          label.innerText = option.value + ' (' + option.count + ')';
          // Set the label for
          label.htmlFor = checkbox.id;

          // Append the checkbox to the div
          div.appendChild(checkbox);
          // Append the label to the div
          div.appendChild(label);

          // Append the div to the fieldset
          fieldset.appendChild(div);

          // Add the field to the filters array
          _this5.filters.push(checkbox);

          // If this value is in the value object, check the checkbox
          if (_this5.value['filter'][filter.field] == undefined) return;
          if (!_this5.value['filter'][filter.field].includes(checkbox.value)) return;

          // Check the checkbox
          checkbox.checked = true;
        });

        // Append the reset button to the fieldset
        fieldset.appendChild(reset);

        // Append the fieldset to the filters
        filters.appendChild(fieldset);
      });

      // Return the filters in the callback
      this.callback('render', filters);
    }

    /*
    The function that gets passed to the onRender method should be heavily based off of the default render function
    NOTE: Some extras are added to the onRender method to allow for the filters array to be populated with the new filter inputs
    You will be responsible for setting inputs to active / adding values to the input during the render based off of the value object
    Your onRender function should end by returning an element that contains all of the filter inputs
    */

    // This method will allow the user to change the render function
  }, {
    key: "onRender",
    value: function onRender(func) {
      var _this6 = this;
      if (typeof func !== 'function') return;
      this.onRenderFunction = function (data) {
        // Create a new form
        var form = document.createElement('form');
        // Get the filters element
        var filters = func(data);

        // Empty the filters array
        _this6.filters = [];

        // Put the filters in the form
        form.appendChild(filters);

        // Loop the form elements and add them to the filters
        _toConsumableArray(form.elements).forEach(function (input) {
          // Add the field to the filters array
          _this6.filters.push(input);
        });

        // The render callback
        _this6.callback('render', filters);
      };
    }
  }, {
    key: "change",
    value: function change() {
      this.callback('change', this.value);
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      // Loop through the filters
      this.filters.forEach(function (filter) {
        // Uncheck the checkbox
        filter.checked = false;
      });

      // Clear the value
      this.value['filter'] = {};

      // The clearFilters callback
      this.callback('clearFilters');
    }
  }]);
  return IndexedSearchFormController;
}(Classy);
export { IndexedSearchFormController as default };